export default "__VITE_ASSET__DZnZd4jU__"